/** Small pieces the Model vs Actual views share. */

import { AlertCircle, Info } from 'lucide-react'
import { Card, CardContent } from '../ui'
import { FORMATTERS, formatVariance } from '../../lib/scienceModelView'

/** A headline figure against its plan. `invert` for figures where over plan is bad, like CAC. */
export function Tile({
  title, value, plan, planLabel = 'Plan', delta, note, format = 'money', invert = false,
  ramped = null, rampedLabel = 'Ramped', rampedDelta = null,
}) {
  const full = FORMATTERS[format].full
  // Whether the gap is good news. CAC over plan is bad; revenue over plan is good.
  const isGood = (d) => (d == null ? null : invert ? d <= 0 : d >= 0)
  const good = isGood(delta)
  return (
    <Card>
      <CardContent className="p-4 space-y-1">
        <div className="text-xs text-muted-foreground">{title}</div>
        <div className="text-xl font-semibold tabular-nums">{full(value)}</div>
        <div className="text-xs text-muted-foreground tabular-nums">
          {planLabel} {full(plan)}
          {delta != null && (
            <span className={`ml-2 font-medium ${good ? 'text-foreground' : 'text-destructive'}`}>
              {good ? '▲' : '▼'} {formatVariance(delta)}
            </span>
          )}
        </div>
        {ramped != null && (
          <div className="text-xs text-muted-foreground tabular-nums">
            {rampedLabel} {full(ramped)}
            {rampedDelta != null && (
              <span className={`ml-2 font-medium ${isGood(rampedDelta) ? 'text-foreground' : 'text-destructive'}`}>
                {isGood(rampedDelta) ? '▲' : '▼'} {formatVariance(rampedDelta)}
              </span>
            )}
          </div>
        )}
        {note && <div className="text-[11px] text-muted-foreground">{note}</div>}
      </CardContent>
    </Card>
  )
}

export function Notice({ children, tone = 'info' }) {
  const Icon = tone === 'error' ? AlertCircle : Info
  return (
    <div className={`flex items-start gap-2 rounded-md border px-3 py-2 text-xs ${tone === 'error' ? 'border-destructive/40 text-destructive' : 'text-muted-foreground'}`}>
      <Icon className="h-4 w-4 shrink-0 mt-0.5" />
      <div>{children}</div>
    </div>
  )
}
